import React, { useEffect, useState } from 'react'
import { CloseButtonModal } from '../../../common/modals/user-table-info/modal-sectors/CloseButtonModal'
import './createForm.css'
import { useAppSubmitForm } from './CreateFormationsControler'
import { GenericInput } from '../../../common/GenericInput/GenericInput'
import { GenericSelect } from '../../../common/GenericSelect/GenericSelect'
import { GenericCreatableSelect } from '../../../common/GenericSelect/GenericCreatableSelect'
import { useSelector } from 'react-redux'
import logger from '../../../../utils/logger'
import { formatDataforGenericSelect } from '../../../../helper/formatDataforGenericSelect'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'





export const CreateFormations = ({ closeBootstrapModal, handleCreation }) => {

  //? textarea 

  const [text, setText] = useState("")


  //? lista de formaciones 

  const selectListOptions = useSelector((data) => data.commonData.lista.formationPlaces)
  logger.debug('selectListOptions: ', selectListOptions)


  const { register, handleSubmit, onSubmit, setValue, message, errors, response } = useAppSubmitForm()



  const actionToast = (text, type) => {

    toast.success(text, {
      autoClose: 2000
    })

  }

  const errorToast = (text) => {
    toast.error(text, {
      autoClose: 2000
    })
  }

  useEffect(() => {

    if (!response?.status) return


    if (response.status >= 200 && response.status < 300) {
      actionToast(response.data?.message || "Operación exitosa")
      handleCreation()
      closeBootstrapModal()
    }


    else {

      const errorMsg = message || "Ocurrió un error inesperado"
      errorToast(errorMsg);

    }
  }, [response])







  const [selectedValue, setSelectedValue] = useState(null);
  const handleSelectChange = (selectedOption) => {
    setSelectedValue(selectedOption)

  }



  return (





    <form
      id="miFormulario"
      className="form-createFormation"
      onSubmit={handleSubmit(onSubmit)}
      onKeyDown={(e) => {
        //👉 Si el usuario presiona Enter en cualquier input, select, react-select, creatable, etc → NO envía el formulario
        //👉 Enter en textarea sí funciona por los saltos de línea
        if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
          e.preventDefault();
        }
      }}
    >
      <CloseButtonModal toggleModal={closeBootstrapModal} btnCloseClass={'btn-formation-close'} />


      <span className="formation-form-title">Nueva Formación</span>

      <div className="form-floating mb-3">

        <GenericInput
          required={true}
          name="name"
          register={register}
          errors={errors}
          label="Nombre de la formación"
          validationMessage='El nombre es obligatorio'

        // placeholder="Matrícula Profesional"
        />

      </div>

      {/* <div className="form-floating mb-3">

        <textarea
          className="form-control form-control-textTarea form-control-height"
          placeholder="Escribe tu descripción aquí..."
          maxLength={200}
          {...register("description")}
        />

      </div> */}

      <div className="form-floating mb-3">
        <textarea
          id="description"
          className="form-control auto-grow"
          placeholder=" "
          maxLength={200}
          {...register("description", {
            onChange: (e) => {
              const el = e.target;

              el.style.height = "auto";

              const minHeight = 56;
              const newHeight = Math.max(el.scrollHeight, minHeight);

              el.style.height = `${newHeight}px`;
            }
          })}
        />
        <label htmlFor="description">Descripción</label>
      </div>




      <div className="form-floating mb-3">

        <GenericCreatableSelect
          {...register('professors', { required: true })}
          // preValue servira cuando tengamos opciones elegidas anteriormente
          setValue={setValue}
          name={'professors'}
          multi={true}
          placeholder='Escriba para buscar o agregar profesores…'
          selectClass={'form-control-height'}
        />

      </div>

      <div className="form-floating mb-3">

        <GenericInput
          required={true}
          name="date"
          register={register}
          errors={errors}
          label="Fecha"
          type='date'
          validationMessage='La fecha de formación es obligatoria'
        // placeholder="Matrícula Profesional"
        />
      </div>

      <div className="form-floating mb-3">


        <GenericInput
          required={false}
          name="maxQuota"
          register={register}
          errors={errors}
          label="Cupos"
          type='number'

        // placeholder="Matrícula Profesional"
        />

      </div>


      <div className="form-floating mb-3 ">

        <GenericSelect

          placeholder={'Seleccione un lugar de formación'}
          multi={false}
          values={formatDataforGenericSelect(selectListOptions)}
          name={'formationPlaceId'}
          closeMenu={true}
          {...register('formationPlaceId', { required: true })}
          setValue={setValue}
          selectClass={'form-control-height'}
        />


      </div>




      <div className="submit-button">
        <input type="submit" className="button-send" value="Crear" />
        <small className="form-text text-muted small-cancelar">
          <Link
            to="/Formations"
            onClick={closeBootstrapModal}
          >Cancelar
          </Link>

        </small>

      </div>

    </form>

  )
}
